export default "__VITE_PUBLIC_ASSET__2cc4ad3e__"